// react imports
import React, { useState } from "react";

// MDBOOTSTRAP IMPORTS
import { MDBInputGroup } from "mdb-react-ui-kit";


/**
 * Props:
 * @param value: string
 * @param onChange: (e) => {}
 * @param onBlur?: (e) => {}
 * @param inputClass?: string
 * @param placeholder?: string
 * @param id?: string
 * @param name?: string
 * @param required?: boolean
 * @returns 
 */
const PasswordInput = (props) => {
  // STATES
  const [hidePassword, setHidePassword] = useState(true);

  return (
    <>
      <MDBInputGroup
        className="jc-password"
        noWrap 
        textAfter={(
          <i 
            className={"fa-regular" + (hidePassword ? ' fa-eye' : ' fa-eye-slash')}
            onClick={() => setHidePassword(!hidePassword)}
          ></i>
        )}
      >
        <input 
          type={hidePassword ? 'password' : 'text'} 
          value={props.value}
          onChange={props.onChange}
          onBlur={props.onBlur}
          className={props.inputClass}
          placeholder={props.placeholder} 
          id={props.id}
          name={props.name}
          required={props.required}
          className="form-control"
        />
      </MDBInputGroup>
    </>
  );
};

export default PasswordInput;